import { render, staticRenderFns } from "./HargaTahunNonAktif.vue?vue&type=template&id=9d86bc5e&"
import script from "./HargaTahunNonAktif.vue?vue&type=script&lang=js&"
export * from "./HargaTahunNonAktif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports